import React, {useContext} from 'react';
import Header from "../../headerone/Main";
import Breadcrumb from "../../Breadcrumb/Main";
import { Container} from "react-bootstrap";
import { LanguageContext } from '../../../LanguageContext';

function CampusOverview() {
    const campusUrl = 'https://files.iittp.ac.in';
    const {language, setLanguages} = useContext(LanguageContext);


    const CampusImg = [


        {
            "img": "https://files.iittp.ac.in/images/demo/iit/campus/IIT_Main_Gate.png",
            "title": "IIT Tirupati Main Gate"
        },
        {
            "img": "https://files.iittp.ac.in/images/demo/iit/campus/IIT_Admin_Block.png",
            "title": "ADMINISTRATIVE BLOCK"
        },
        {
            "img": "https://files.iittp.ac.in/images/demo/iit/campus/IIT_DB2_Block.png",
            "title": "DEPARTMENT BLOCK -2"
        },
        {
            "img": "https://files.iittp.ac.in/images/demo/iit/campus/IIT_DB1_Block.png",
            "title": "DEPARTMENT BLOCK - 1"
        },
        {
            "img": "https://files.iittp.ac.in/images/demo/iit/campus/IIT_CIF_Block.png",
            "title": "LECTURER HALL COMPLEX"
        },
        {
            "img": "https://files.iittp.ac.in/images/demo/iit/campus/IIT_Residential_Zone.png",
            "title": "RESIDENTIAL ZONE"
        },
        {
            "img": "https://files.iittp.ac.in/images/demo/iit/campus/IIT_Visitor_Zone.png",
            "title": "VISITOR HOSTEL"
        },
        {
            "img": "https://files.iittp.ac.in/images/demo/iit/campus/IIT_Pond_1.png",
            "title": "POND-1"
        },
        {
            "img": "https://files.iittp.ac.in/images/demo/iit/campus/IIT_Pond_2.png",
            "title": "POND-2"
        },
        {
            "img": "https://files.iittp.ac.in/images/demo/iit/campus/c1.jpg",
            "title": "SPORTS COMPLEX"
        },
        {
            "img": "https://files.iittp.ac.in/images/demo/iit/campus/c2.jpg",
            "title": "LABORATORY BLOCKS"
        },
        {
            "img": "https://files.iittp.ac.in/images/demo/iit/campus/h6.jpg",
            "title": "HEALTH CENTRE BLOCK"
        },
        {
            "img": "https://files.iittp.ac.in/images/demo/iit/campus/c7.JPG",
            "title": "SOUTH GATE"
        }
    ]

    const HostalImg =

        [
            {
                "img": "https://files.iittp.ac.in/images/demo/iit/campus/IIT_Hostel_Zone.png",
                "title": "HOSTEL ZONE"
            },
            {
                "img": "https://files.iittp.ac.in/images/demo/iit/campus/h1.jpeg",
                "title": ""
            },
            {
                "img": "https://files.iittp.ac.in/images/demo/iit/campus/h2.jpg",
                "title": ""
            },
            {
                "img": "https://files.iittp.ac.in/images/demo/iit/campus/c3.jpg",
                "title": ""
            },
            {
                "img": "https://files.iittp.ac.in/images/demo/iit/campus/c4.jpg",
                "title": ""
            },
            {
                "img": "https://files.iittp.ac.in/images/demo/iit/campus/h3.jpeg",
                "title": ""
            },
            {
                "img": "https://files.iittp.ac.in/images/demo/iit/campus/h4.jpeg",
                "title": ""
            },
            {
                "img": "https://files.iittp.ac.in/images/demo/iit/campus/h5.jpg",
                "title": ""
            }
        ]

    const EventImg =

        [
            {
                "img": "https://files.iittp.ac.in/images/demo/iit/campus/IYD_1.png",
                "title": ""
            },
            {
                "img": "https://files.iittp.ac.in/images/demo/iit/campus/IYD_2.png",
                "title": ""
            },
            {
                "img": "https://files.iittp.ac.in/images/demo/iit/campus/IYD_3.png",
                "title": ""
            },
            {
                "img": "https://files.iittp.ac.in/images/demo/iit/campus/IYD_4.png",
                "title": ""
            },
            {
                "img": "https://files.iittp.ac.in/images/demo/iit/campus/e1.jpg",
                "title": ""
            },
            {
                "img": "https://files.iittp.ac.in/images/demo/iit/campus/e2.jpg",
                "title": ""
            },
            {
                "img": "https://files.iittp.ac.in/images/demo/iit/campus/e3.jpg",
                "title": ""
            },
            {
                "img": "https://files.iittp.ac.in/images/demo/iit/campus/e4.jpg",
                "title": ""
            },
            {
                "img": "https://files.iittp.ac.in/images/demo/iit/campus/e5.jpg",
                "title": ""
            },
            {
                "img": "https://files.iittp.ac.in/images/demo/iit/campus/e6.jpg",
                "title": ""
            },
            {
                "img": "https://files.iittp.ac.in/images/demo/iit/campus/e7.jpg",
                "title": ""
            },
            {
                "img": "https://files.iittp.ac.in/images/demo/iit/campus/e8.jpg",
                "title": ""
            },
            {
                "img": "https://files.iittp.ac.in/images/demo/iit/campus/e9.jpg",
                "title": ""
            }
        ]
    const SportsImg =
        [
            {
                "img": "https://files.iittp.ac.in/images/demo/iit/campus/s1.jpg",
                "title": ""
            },
            {
                "img": "https://files.iittp.ac.in/images/demo/iit/campus/s2.jpg",
                "title": ""
            },
            {
                "img": "https://files.iittp.ac.in/images/demo/iit/campus/s3.jpg",
                "title": ""
            },
            {
                "img": "https://files.iittp.ac.in/images/demo/iit/campus/s4.jpg",
                "title": ""
            },
            {
                "img": "https://files.iittp.ac.in/images/demo/iit/campus/s5.jpg",
                "title": ""
            },
            {
                "img": "https://files.iittp.ac.in/images/demo/iit/campus/s6.jpg",
                "title": ""
            },
            {
                "img": "https://files.iittp.ac.in/images/demo/iit/campus/s7.jpg",
                "title": ""
            },
            {
                "img": "https://files.iittp.ac.in/images/demo/iit/campus/s8.jpg",
                "title": ""
            }
        ]


    const TrekkingImg =

        [
            {
                "img": "https://files.iittp.ac.in/images/demo/iit/campus/t1.jpg",
                "title": ""
            },
            {
                "img": "https://files.iittp.ac.in/images/demo/iit/campus/t2.jpg",
                "title": ""
            },
            {
                "img": "https://files.iittp.ac.in/images/demo/iit/campus/t3.jpg",
                "title": ""
            },
            {
                "img": "https://files.iittp.ac.in/images/demo/iit/campus/t4.jpg",
                "title": ""
            },
            {
                "img": "https://files.iittp.ac.in/images/demo/iit/campus/t5.jpg",
                "title": ""
            }
        ]

    const WorkshopImg =
        [
            {
                "img": "https://files.iittp.ac.in/images/demo/iit/campus/w1.jpg",
                "title": ""
            },
            {
                "img": "https://files.iittp.ac.in/images/demo/iit/campus/w2.jpg",
                "title": ""
            },
            {
                "img": "https://files.iittp.ac.in/images/demo/iit/campus/w3.jpg",
                "title": ""
            },
            {
                "img": "https://files.iittp.ac.in/images/demo/iit/campus/w4.jpg",
                "title": ""
            },
            {
                "img": "https://files.iittp.ac.in/images/demo/iit/campus/w5.jpg",
                "title": ""
            },
            {
                "img": "https://files.iittp.ac.in/images/demo/iit/campus/w6.jpg",
                "title": ""
            },
            {
                "img": "https://files.iittp.ac.in/images/demo/iit/campus/w7.jpg",
                "title": ""
            }
        ]



    return (
        <>
            <Header />
            <Breadcrumb title="Home"   titleHi='मुख्य पृष्ठ' subtitle="CAMPUS OVERVIEW" subtitleHi="परिसर का संक्षिप्त विवरण" bgImage="url(/assets/img/BreadCrumCustom/ImageFaculty.jpg)" />
            
                <section className="team-area fix p-relative pt-120 pb-80">
                <Container>
                <div className="row mb-4">
                    <div className="col-12">
                        <h4 className="text-center">{language==='en'?'Campus overview':'परिसर का संक्षिप्त विवरण'}</h4>
                    </div>
                </div>
                <div className="row">
                    <div className="col-12">
                
                                <p className="card-text text-justify">
                                    {language === 'en' ? 
                                        'In pursuance of the recommendations of the Site Selection Committee (SSC) and with the approval of the competent authority, it was decided to set up IIT Tirupati’s permanent campus at a site in Merlapaka Village, Yerpedu (Mandal), Tirupati District, Andhra Pradesh in accordance with Section 93 of the Andhra Pradesh Reorganisation Act, 2014. The Government of Andhra Pradesh has proposed to provide land to an extent of about 530 acres for the development of the permanent campus. This land is located on the Yerpedu–Venkatagiri road, 22 km from Tirupati town and 14 km from the airport. It has a scenic mountain backdrop. The permanent campus is expected to be operational by 2019.' 
                                        :
                                        'साइट चयन समिति (एसएससी) की संस्तुतियों के अनुसरण में और सक्षम प्राधिकारी के अनुमोदन से, आंध्र प्रदेश पुनर्गठन अधिनियम, 2014 की धारा 93 के अनुसार, आंध्र प्रदेश के तिरुपति जिले के एर्पेडु (मंडल) के मेरलापाका ग्राम में एक जमीन पर आईआईटी तिरुपति का स्थायी परिसर स्थापित करने का निर्णय लिया गया। आंध्र प्रदेश सरकार ने स्थायी परिसर के विकास के लिए लगभग 530 एकड़ भूमि उपलब्ध कराने का प्रस्ताव किया है। यह भूमि एर्पेडु-वेंकटगिरी मार्ग पर स्थित है, जो तिरुपति शहर से 22 किमी और हवाई अड्डे से 14 किमी दूर है। इसकी पृष्ठभूमि में एक सुंदर पर्वत है। स्थायी परिसर के 2019 तक चालू होने की उम्मीद है।' } 
                                </p>
                     
                    </div>
                </div>
                <div className="row mt-5">
                    <div className="col-12 text-center">

                   
                        <a href={`${campusUrl}/images/demo/iit/campus/map.png`} data-lightbox="pc" title="">
                            <img src={`${campusUrl}/images/demo/iit/campus/map.png`} width={500} height={500} alt="Campus" className="img-fluid" />
                        </a>
                    </div>
                </div>
                <div className="row mt-5">
                    <div className="col-12">
               
                                <p className="card-text text-justify">
                                    {language==='en'?
                                    'IIT Tirupati is expected to be a 12,000 student campus in the coming decades. The Master plan for IIT Tirupati permanent campus is ready, and construction activities will start soon.'
                                    :
                                    'आने वाले दशकों में आईआईटी तिरुपति के परिसर में विद्यार्थियों की संख्या 12,000 तक पहुँचने की उम्मीद है। आईआईटी तिरुपति के स्थायी परिसर के लिए मास्टर प्लान तैयार है, और निर्माण गतिविधियाँ जल्द ही प्रारंभ होंगी।'
                                    }
                                </p>
                
                    </div>
                </div>

                {/* Campus */}
                <div className="row mt-3">
                    <h4 className='c-headline mt-5 mb-3'>{language==='en'?'Campus':'परिसर'}</h4>

                    <div className="grid col3 row wow fadeInUp  animated" data-animation="fadeInUp" data-delay=".4s" >
                        {CampusImg.map((item, Index) => (
                            <div className="financial col-4 mt-3" key={Index}>
                                <figure className="gallery-image">
                                    <img src={item.img} alt="Loading image.." className="img" title={item.title} width={350} height={200} />
                                </figure>
                            </div>
                        ))}
                    </div>
                </div>




                {/* HostalImg */}
                <div className="row mt-3">
                    <h4 className='c-headline mt-5 mb-3'>{language==='en'?'Hostels':'छात्रावास'}</h4>

                    <div className="grid col3 row wow fadeInUp  animated" data-animation="fadeInUp" data-delay=".4s" >
                        {HostalImg.map((item, Index) => (
                            <div className="financial col-4 mt-3" key={Index}>
                                <figure className="gallery-image">
                                    <img src={item.img} alt="img" className="img" title={item.title} width={350} height={200} />
                                </figure>
                            </div>
                        ))}
                    </div>
                </div>




                {/* EventImg */}
                <div className="row mt-3">
                    <h4 className='c-headline mt-5 mb-3'>{language==='en'?'Events':'आयोजन'}</h4>

                    <div className="grid col3 row wow fadeInUp  animated" data-animation="fadeInUp" data-delay=".4s" >
                        {EventImg.map((item, Index) => (
                            <div className="financial col-4 mt-3" key={Index}>
                                <figure className="gallery-image">
                                    <img src={item.img} alt="img" className="img" title={item.title} width={350} height={200} />
                                </figure>
                            </div>
                        ))}
                    </div>
                </div>



                {/* Sports */}
                <div className="row mt-3">
                    <h4 className='c-headline mt-5 mb-3'>{language==='en'?'Sports':'क्रीडा'}</h4>

                    <div className="grid col3 row wow fadeInUp  animated" data-animation="fadeInUp" data-delay=".4s" >
                        {SportsImg.map((item, Index) => (
                            <div className="financial col-4 mt-3" key={Index}>
                                <figure className="gallery-image">
                                    <img src={item.img} alt="img" className="img" title={item.title} width={350} height={200} />
                                </figure>
                            </div>
                        ))}
                    </div>
                </div>



                {/* TREKKING */}
                <div className="row mt-3">
                    <h4 className='c-headline mt-5 mb-3'>{language==='en'?'Trekking':'ट्रैकिंग'}</h4>

                    <div className="grid col3 row wow fadeInUp  animated" data-animation="fadeInUp" data-delay=".4s" >
                        {TrekkingImg.map((item, Index) => (
                            <div className="financial col-4 mt-3" key={Index}>
                                <figure className="gallery-image">
                                    <img src={item.img} alt="img" className="img" title={item.title} width={350} height={200} />
                                </figure>
                            </div>
                        ))}
                    </div>
                </div>

                {/* WORKSHOP */}
                <div className="row mt-3 mb-5">
                    <h4 className='c-headline mt-5 mb-3'>{language==='en'?'Workshop':'कार्यशाला'}</h4>

                    <div className="grid col3 row wow fadeInUp  animated" data-animation="fadeInUp" data-delay=".4s" >
                            {WorkshopImg.map((item, Index) => (
                            <div className="financial col-4 mt-3" key={Index}>
                                <figure className="gallery-image">
                                    <img src={item.img} alt="img" className="img" title={item.title} width={350} height={200} />
                                </figure>
                            </div>
                        ))}
                    </div>
                </div>

                </Container>
            </section>

    
        </>
    );
}

export default CampusOverview;
